'use client';

import {
    CountrySpecificitiesRule,
    DynamicHrefValue,
    DynamicIconValue,
    DynamicLabelValue,
    DynamicTagValue,
    ResultServerActionType,
} from '@headless-workspace/core-domain';
import { ArrayHelpers, ObjectHelpers } from '@headless-workspace/utils';
import { UserConnectionStatus, UserInfo } from '../../../../src';

export enum CountrySpecificityRuleKey {
    UserStatus = 'user.status',
    UserLoyaltyStatus = 'user.loyalty.status',
    UserHasNotAttribute = 'user.has.not.attribute',
    UserLastOfferStatus = 'user.offer.status',
}

const applySpecificityRule = (rule: CountrySpecificitiesRule, userInfo?: ResultServerActionType<UserInfo>): boolean => {
    try {
        switch (rule.key) {
            case CountrySpecificityRuleKey.UserStatus: {
                return (
                    userInfo?.type === 'success' && ArrayHelpers.findMatchingValue(rule.value, userInfo?.data.status)
                );
            }
            case CountrySpecificityRuleKey.UserLoyaltyStatus:
            case CountrySpecificityRuleKey.UserLastOfferStatus: {
                return (
                    userInfo?.type === 'success' &&
                    userInfo.data.status === UserConnectionStatus.Registered &&
                    !!userInfo.data.loyalty &&
                    ArrayHelpers.findMatchingValue(rule.value, userInfo.data.loyalty?.sephoraCard)
                );
            }
            case CountrySpecificityRuleKey.UserHasNotAttribute: {
                return (
                    userInfo?.type === 'success' &&
                    userInfo.data.status === UserConnectionStatus.Registered &&
                    !ObjectHelpers.hasAttribute(userInfo.data, rule.value as string)
                );
            }
            default:
                return false;
        }
    } catch (error) {
        return false;
    }
};

export const findSpecificityRule = <
    T extends DynamicLabelValue | DynamicIconValue | DynamicHrefValue | DynamicTagValue,
>(
    elements: T[],
    userInfo?: ResultServerActionType<UserInfo>,
): T | undefined => {
    return elements.find((item) => {
        return applySpecificityRule(item.rule, userInfo);
    });
};
